<template>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 program-page-overview-multicare" v-if="addons && times && base">

		<div class="price-box-fixed" v-if="!isQuickAdd && (!simulate || (simulate && simulate.code == undefined)) && (current && current.package_state_id == 2)" :class="{ 'price-calculated': simulate && simulate.individual_cost }">
            <div class="title">
                <span class="price" v-if="!individual_days && simulate && simulate.individual_cost > 0 && simulate.original_cost_calculation.length > 0"><b>{{ locale.text_total_price }}</b> <i> {{ currencyFormat(simulate.individual_cost) }}</i></span>
                <span class="price" v-else-if="simulate && simulate.code == 500"><b>Something went wrong!</b></span>
                <span class="price" v-else-if="current && (selection.packages.length == 0 || selection.participants.length == 0)"><b>{{ $root.config.use_short_weeks && individual_days ? locale.text_total_price : ((!individual_days) || (individual_days && selection.days_running.length > 0) ? 'From': '') }}</b> <i>{{ (!individual_days ? (fromPrice !== null ? currencyFormat(fromPrice) : currencyFormat(current.price)) : (selection.days_running.length > 0 ? currencyFormat(individual_days_from_price) : ' ')) }}</i></span>
                <span class="price" v-else-if="!individual_days && simulate && parseFloat(simulate.individual_cost) > 0"><b>{{ locale.text_total_price }}</b> <i> {{ currencyFormat(simulate.individual_cost) }}</i></span>
                <i class="fa fa-spinner fa-pulse fa-2x" v-else></i>
            </div>
		</div>

        <div v-if="individual_days && this.venue && this.venue.venue_notes">
            <div class="content-block-alone darker startScrolling" style="background: #fbc51e;!important">
                <div class="title">
                    <h1>{{ locale.text_notes_title }} : {{ this.venue.venue_notes }}</h1>
                </div>
            </div>
        </div>

        <div v-if="individual_days && this.programmes && this.programmes.length > 0 && this.programmes.some(programme => programme.availability && Object.values(programme.availability).some(num => num <= 0) && (programme.prog_id == 1 || programme.prog_id == 17 || programme.prog_id == 18))">
            <div class="content-block-alone darker startScrolling" style="background-color: #e41b13;!important" v-if="!isQuickAdd">
                <div class="title">
                    <h1>{{ locale.text_availability_title }} : <span v-html="locale.text_subscribe_to_notify_short_week"></span></h1>
                </div>
            </div>
            <div class="fields dropdown" v-else>
                <label style="background-color: #e41b13;!important">{{ locale.text_availability_title }} : <span v-html="locale.text_subscribe_to_notify_short_week"></span></label>
            </div>
        </div>

        <br>

        <div class="content-block-alone" v-if="individual_days"><div class="title"><h1 v-html="optionsHeader"></h1></div></div>
        <div class="content-block-alone flexicare-description" v-if="individual_days">
            <div class="full-width add-on-block-outer">
                <div class="box-layout-inner add-on-block">
                    <div class="full-width-field-block">

                        <div class="add-on-checkbox-container">

                        </div>
                        <div class="block-content">
                            <div class="content-block" v-html="base.full_description"></div>
                        </div>

                        <div class="block-image" v-bind:style="{ background: 'url('+base.image_url+') center center / contain no-repeat' }"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form" id="multicareBooking">
            <span v-if="individual_days" class="startScrolling" :class="{'individual-left': !this.isQuickAdd, 'individual_days': !$root.config.use_short_weeks, 'short_weeks': $root.config.use_short_weeks }">
                <div v-if="individual_days && ((this.venue && !(this.venue.id == 257 || this.venue.id == 281 || this.venue.id == 157 || this.venue.id == 75)) || (!this.venue || this.venue === undefined))" class="col-lg-12 col-sm-12">
                    <div class="box-layout-inner yellow">
                        <div class="half-half">
                            <div class="full-width" style="font-size: 20px;">
                                Please select a minimum of 3 days per week
                            </div>
                        </div>
                    </div>
                </div>
                <short-weeks-selection v-if="$root.config.use_short_weeks" v-bind:current="current" v-bind:toSwap="toSwap" v-bind:packages="addons" v-bind:selection="selection"></short-weeks-selection>
                <individual-days-selection @reload="load" v-else v-bind:current="current" v-bind:toSwap="toSwap" v-bind:packages="addons" v-bind:selection="selection"></individual-days-selection>
            </span>
            <span v-else>

                <div v-if="current && current.availability && Object.values(current.availability).some(num => num <= 0) && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18)">
                    <div class="content-block-alone darker startScrolling" style="background-color: #e41b13;!important" v-if="!isQuickAdd">
                        <span class="title">
                            <p class="text-center" style="color: white;" v-html="'One or more of the ' + current.start_date.toDate().formatRange(current.days_running, false) + ' ' + locale.text_individual_days_sold_out + '<br>' + locale.text_subscribe_to_notify"></p>
                        </span>
                    </div>
                </div>

                <div v-if="this.venue && this.venue.venue_notes">
                    <div class="content-block-alone darker startScrolling" style="background: #fbc51e;!important" v-if="!isQuickAdd">
                        <div class="title">
                            <h1>{{ locale.text_notes_title }} : {{ this.venue.venue_notes }}</h1>
                        </div>
                    </div>
                    <div class="fields dropdown" v-else>
                        <label>{{ locale.text_notes_title }} : {{ this.venue.venue_notes }}</label>
                    </div>
                </div>

                <div v-if="current.availability && current.availability !== undefined && (Object.values(current.availability).some(num => num < 10) && Object.values(current.availability).every(num => num > 0) && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18))">
                    <div class="content-block-alone darker startScrolling" style="background-color: #e41b13;!important" v-if="!isQuickAdd">
                        <div class="title">
                            <h1>{{ locale.text_availability_title }} : Limited availability remaining at this venue, on this week. Book to secure your place.</h1>
                        </div>
                    </div>
                    <div class="fields dropdown" v-else>
                        <label>{{ locale.text_availability_title }} : Limited availability remaining at this venue, on this week. Book to secure your place.</label>
                    </div>
                </div>

                <div class="content-block-alone" v-if="!isQuickAdd">
                    <div class="title">
                        <h1>{{ locale.text_programme_title }}</h1>
                    </div>
                </div>
                
                <div class="fields dropdown" v-else>
                    <label v-if="addons.length > 0">{{ locale.text_programme_title }}</label>
                </div>
                <div class="box-layout-inner course-list-blocks">
                    <transition-group name="list">
                        <addon-selection v-bind:locale="locale" v-bind:baseProgramme="optionsHeader" v-bind:selection="selection" v-bind:current="current" v-for="(addon, key) in addons" v-bind:key="key" v-bind:base="base" v-bind:package="addon" v-bind:checked="addons.length == 1 || addon.id == (toSwap ? current.package_id : current.id)"></addon-selection>
                    </transition-group>
                </div>

            </span>
            <div class="content-block-alone" :class="{'individual-right':individual_days}" v-if="!this.isQuickAdd">
                <div class="title">
                    <h1>{{ locale.text_participant_title }}</h1>
                </div>
            </div>
            <div class="box-layout-inner attending" :class="{'individual-right':individual_days}" v-if="!this.isQuickAdd">
                <whos-attending @addchosen="addParticipant" @removechosen="removeParticipant" v-bind:current="current" v-bind:bookingId="$root.getCookie('kingscamps_booking_id')" v-bind:selection="selection"></whos-attending>
            </div>
            <transition name="slide-fade">
                <div class="box-layout-inner yellow" v-if="simulate && simulate.code != undefined && simulate.message.indexOf('Not authorised') > -1">
                    <div class="half-half">
                        <div class="full-width">
                            <div class="price-subtotal alerts">
                                <span>{{ locale.text_not_authorised }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-layout-inner alert" v-else-if="simulate && simulate.code != undefined">
                    <div class="half-half blue">
                        <div class="full-width dark-red">
                            <div class="price-subtotal">
                                <span>{{ simulate.message }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="box-layout-inner dark-blue financial-summary cart-totals stopScrolling" v-else-if="simulate && simulate.individual_cost != null && (current.prog_id != 1 || (!this.individual_days && current.availability && Object.values(current.availability).every(num => num > 0) && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18)) || (this.individual_days && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18)))">

                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" v-if="isEditing && toSwap || isQuickAdd">
                        <router-link :to="{ name: 'cart.basket' }" class="cta-button blue">Go back (Discard changes)</router-link>
                    </div>

                    <div class="col-xs-12 col-md-6 col-lg-6 cart-totals" :class="{ 'col-sm-6 col-sm-offset-6 col-md-offset-6 col-lg-offset-6': !toSwap && !isQuickAdd, 'col-sm-6 col-md-offset-2 col-lg-offset-2': toSwap || isQuickAdd }" col-sm-12>

                         <transition-group name="slide-fade">

                             <div class="basket-subtotal" key="basket-total" v-if="simulate.original_cost && (fees.length > 0 || discounts.length > 0)">
                                 <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal price-original-total">
                                     <!-- <span class="vertical">{{ locale.text_original_price }}{{ (simulate.original_cost_calculation ? ' ('+simulate.original_cost_calculation+')' : '' ) }}: </span> -->
                                     <span class="vertical">{{ locale.text_original_price }}: </span>
                                 </div>
                                 <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal price-original-total">
                                     <b class="vertical" v-if="simulate.original_cost">{{ currencyFormat(simulate.original_cost) }}</b>
                                     <div class="loader" v-else><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
                                 </div>
                             </div>

                            <div class="fee-container" v-if="fees.length > 0" v-for="fee in fees" key="fee-container">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                    <b>{{ fee.discount_description }}:</b>
                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                    <b>{{ currencyFormat(fee.discount_amount) }}</b>
                                </div>
                            </div>

                            <div class="discount-container" v-if="discounts.length > 0" v-for="(discount, discountId) in discounts" :key="'discount-container'+discountId">
                                <div v-if="discount.discount_amount > 0">
                                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                        <b>{{ discount.discount_description }}:</b>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                        <b>- {{ currencyFormat(discount.discount_amount) }}</b>
                                    </div>
                                </div>
                            </div>

                             <div class="basket-total" key="basket-total-2" v-if="simulate.individual_cost != null">
                                 <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal">
                                     <span v-if="fees.length > 0 || discounts.length > 0" class="vertical">{{ locale.text_total_price }}: </span>
									 <span v-else class="vertical">{{ locale.text_total_price }} 
                                        <!-- <small>{{ (simulate.original_cost_calculation ? '('+simulate.original_cost_calculation+')' : '' ) }}:</small>  -->
                                    </span>
                                 </div>
                                 <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal">
                                     <b class="vertical" v-if="simulate.individual_cost != null">{{ currencyFormat(simulate.individual_cost) }}</b>
                                     <div class="loader" v-else><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
                                 </div>
                             </div>

                            <div class="checkout-cta" key="checkout-cta" v-if="simulate.individual_cost != null && (current.prog_id != 1 || (!this.individual_days && current.availability && Object.values(current.availability).every(num => num > 0) && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18)) || (this.individual_days && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18)))">
                                <input v-if="!progressing" @click="progress" type="submit" class="cta-button red checkout" :value="(isEditing && toSwap ? 'Make Changes' : 'Add to basket'  ) + (disabled ? ' (No changes)' : '')" :class="{ 'disabled': disabled }" :disabled="disabled" />
                                <button class="cta-button red checkout disabled" disabled v-else><i class="fa fa-spinner fa-pulse"></i> &nbsp;Please wait</button>
                            </div>
                         </transition-group>

					</div>
                </div>

                <div class="box-layout-inner yellow" v-else>
                    <div class="half-half">
                        <div class="full-width">
                            <div class="price-subtotal alerts">
                                <span class="vertical" v-if="current && (Object.values(current.availability).some(num => num <= 0) && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18)) && !individual_days">
                                    <p style="color: white!important;" v-html="'One or more of the ' + current.start_date.toDate().formatRange(current.days_running, false) + ' ' + locale.text_individual_days_sold_out + '<br>' + locale.text_subscribe_to_notify"></p>
                                </span>
                                <span class="vertical" v-if="individual_days && current && (Object.values(current.availability).every(num => num <= 0) && (current.prog_id == 1 || current.prog_id == 17 || current.prog_id == 18))">
                                    <p v-html="'The ' + current.start_date.toDate().formatRange(current.days_running, false) + ' ' + locale.text_individual_days_sold_out + '<br>' + locale.text_subscribe_to_notify"></p>
                                </span>
                                <span class="vertical" v-else-if="current && current.package_state_id == 3 && !individual_days">
                                    <a :href="'tel:'+$root.config.kings_phone_number" v-html="locale.text_individual_days_call_to_book + ' ' + current.start_date.toDate().formatRange(current.days_running, false)"></a>
                                </span>
                                <span class="vertical" v-else-if="current && current.package_state_id == 4 && !individual_days">
                                    <a :href="'tel:'+$root.config.kings_phone_number" v-html="'The ' + current.start_date.toDate().formatRange(current.days_running, false) + ' ' + locale.text_individual_days_sold_out + '<br>' + locale.text_subscribe_to_notify"></a>
                                </span>
                                <span class="vertical" v-else-if="current && current.package_state_id == 5 && !individual_days">
                                    <a :href="'tel:'+$root.config.kings_phone_number" v-html="'The ' + current.start_date.toDate().formatRange(current.days_running, false) + ' ' + locale.text_individual_days_cancelled"></a>
                                </span>
								
                                <span class="vertical" v-else-if="selection.hour == null && selection.packages.length == 0 && !individual_days" v-html="locale.text_error_hours"></span>
								<span class="vertical" v-else-if="selection.participants.length == 0" v-html="locale.text_error_participant"></span>
                                <span class="vertical" v-else-if="selection.packages.length == 0 && selection.participants.length == 0" v-html="locale.text_error_package_and_participant"></span>
                                <span class="vertical" v-else-if="selection.days_running.length == 0 && individual_days" v-html="$root.config.use_short_weeks ? locale.text_error_short_weeks : locale.text_error_days"></span>
                                <span class="vertical" v-else-if="selection.packages.length == 0" v-html="locale.text_error_package"></span>

								<div class="loader" v-else><i class="fa fa-spinner fa-pulse fa-2x"></i></div>

                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <!-- <pre v-html="current"></pre> -->

        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
        <p class="text-center" v-if="loading"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
        <div class="box-layout-inner" v-else>
            <div class="title-block" v-html="locale.text_empty"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['quick', 'edit', 'toSwap', 'days', 'participant', 'quickSelection'],
        data () {
            return {
                base: null, programmes: [], times: [],
                optionsHeader: "", addons: [], fees: [],
                current: undefined, discounts: [],
				fromPrice: null,
				currentProgrammeIds: "",
                token: null,
                selection: {
                    hour: undefined,
                    packages: [],
                    participants: [],
                    days_running: [],
                }, simulate: undefined, token: null,
                disabled: false, loading: true, progressing: false
            }
        },
        methods: {
            currencyFormat: function ( value ) {
                return '£' + parseFloat(Math.abs(value)).toFixed(2);
            },
            progress: function () {
                this.progressing = true;
                var participants = this.selection.participants;
                var chosenPackages = this.selection.packages;

                var params = {};

				chosenPackages.forEach(packageId => {
					participants.forEach(participantId => {
						params[participantId.toString()+"|"+packageId.toString()] = {
							package_id: packageId,
							participant_id: participantId,
						};
						if(this.selection.days_running[packageId])
							params[participantId.toString()+"|"+packageId.toString()]['dates_attending'] = this.selection.days_running[packageId];
					})
				});

                if(this.toSwap != undefined && this.toSwap) {
                    axios.put('camp-booking/bookings/' + this.$route.params.bookingId + '/items/' + this.$route.params.bookingItemId + '/swap' + (this.individual_days ? '/similar' : ''), params)
                        .then(response => {
                            // Clear localStorage selections after successful update
                            localStorage.removeItem('individualDaysSelected');
                            this.$root.alert('Item has been updated', 'success');
                            this.$router.push({ name: 'cart.basket' });
                        }).catch(error => {
                            this.progressing = false;
                            this.$root.alert(error.response.data.data.message);
                        });
                } else {
                    axios.post('camp-booking/bookings/' + this.$root.getCookie('kingscamps_booking_id') + '/items', params)
                        .then(response => {
                            // Clear localStorage selections after successful add
                            localStorage.removeItem('individualDaysSelected');
                            
                            this.$emit('updatebuilder', {
                                method: 'append',
                                data: {
                                    booking: {
                                        items: response.data.data,
                                        selection: this.selection
                                    }
                                }
                            });

                            //Determining whether to show a plural version of the message if there are multiple items being added
                            if(chosenPackages.length > 1) {
                                this.$root.alert(this.$root.locale.basket.quick_add_edit.text_item_added_plural, 'success');
                            } else if(chosenPackages.length == 1){
                                this.$root.alert(this.$root.locale.basket.quick_add_edit.text_item_added, 'success');
                            }

                            /** Updating the basket count **/
                            this.$root.updateBasketCount();

                            this.$router.push({name: 'cart.basket'});
                        }).catch(error => {
                            this.progressing = false;
                        });
                }
            },
            addParticipant: function (id) {
                //Checking if the participant is already added
                if(this.selection.participants.indexOf(id) < 0)
                    this.selection.participants.push(id);
            },
            removeParticipant: function (id) {
                this.selection.participants.splice(this.selection.participants.indexOf(id), 1);
            },
            updateAddons: function(hourSelection, priceChange) {
                /**
                 * Updates the available packages when changing the selected hours
                 **/

				//Do we have a current defined package?
				var previousSelectionId = undefined;
				if (!this.individual_days && this.edit && !this.quick) {
					previousSelectionId = this.toSwap.package_id;
				} else if (!this.individual_days && this.selection.packages != undefined) {
					previousSelectionId = this.selection.packages[0];
				}

				//Set the packages
                var packages = [];
                var current = undefined;
                this.programmes.forEach(function(programme, key) {
                    if (programme.times_id == hourSelection && programme.programme_ids) {
						if(!current) {
                            current = programme;
						}
                        packages.push(programme);
                    }
                });


				//Do we have a previous package?
				var preselectMatch = undefined;
				if (!this.individual_days && previousSelectionId != undefined) {

					var previousPackage = undefined;
					var packageMatch = undefined;
					var programmeMatch = undefined;
					var fallbackMatch = undefined;

					//Loop through programmes to get previous package
					this.programmes.filter(programme => {
						if (programme.id == previousSelectionId) {
							previousPackage = programme;
						}
					});

					//Loop through programmes
					this.programmes.filter(programme => {

						//If the package matches the hours
						if (programme.times_id == hourSelection) {

							if (previousPackage != undefined && (programme.id == previousPackage.id)) {

								//Exact match on ID
								preselectMatch = true;
								packageMatch = programme;

							} else if (previousPackage !== undefined && programme.times_id == hourSelection && programme.programme_ids.sort().join(',')=== previousPackage.programme_ids.sort().join(',')) {

								//Match on programmes
								preselectMatch = true;
								programmeMatch = programme;

							} else if (programme.times_id == hourSelection) {

								//Last resort match
								preselectMatch = true;
								fallbackMatch = programme;
							}

						}

					});

					//Set current in order of relevance
					if (packageMatch != undefined) {
						current = packageMatch;
					} else if (programmeMatch != undefined) {
						current = programmeMatch;
					} else {
						current = fallbackMatch;
					}


				}

				//Set the current selection
                this.addons = packages.filter(val => val);
                this.current = current;
                //Setting the selection variable for the simulate call if there is only one package available.
                if(this.addons.length == 1 && !this.individual_days) {
                    this.selection.packages = [current.id];
                    this.selection.min_age = current.min_age;
                    this.selection.max_age = current.max_age;
                } else {
                    this.selection.packages = [];
                }


                if(this.current != undefined) {
                    this.selection.hour = {
                        id: hourSelection,
                        price: priceChange
                    };
                } else {
                    this.selection.hour = null;
                }

				//Have we found a match?
				if (preselectMatch == true) {
					this.selection.packages = [current.id];
                }

            },
            load: function () {

              /**
              * Setting or Getting a booking_id
              **/
              this.$root.setBookingId();

            /** Getting the current venue **/
            if(this.$route.params.hasOwnProperty('venueId'))
                axios.get('/camp-booking/venues/'+this.$route.params.venueId)
                    .then(response => {
                        this.venue = response.data.data;
                    })

              var options = {
                age: (this.$route.query.hasOwnProperty('age') ? this.$route.query.age : (this.$root.builder.hasOwnProperty('age') ? this.$root.builder.age : null)),
                min_age: (this.$route.query.hasOwnProperty('min_age') ? this.$route.query.min_age : (this.$root.builder.hasOwnProperty('min_age') ? this.$root.builder.min_age : null)),
                week: (this.$route.query.hasOwnProperty('week') ? this.$route.query.week : (this.$root.builder.hasOwnProperty('date') ? this.$root.builder.date.id : null)),
                base: (this.$route.query.hasOwnProperty('base') ? this.$route.query.base : (this.$root.builder.hasOwnProperty('package') ? this.$root.builder.package.base.id : null)),
                days: (this.$route.query.hasOwnProperty('days') ? this.$route.query.days == "true" || this.$route.query.days == true : (this.$root.builder.hasOwnProperty('package') && !this.quick ? this.$root.builder.package.individual_days : null))
              }

              //options.age == null
              if ((options.week == null || options.base == null) && !options.days && !this.isQuickAdd)
                this.$router.push({
                    name: 'booking.packages',
                    query: this.$route.query
                });

              if (this.isQuickAdd && this.participant)
                this.selection.participants = [this.participant.id];
              /**
              * Getting all the venues to fill the select dropdown to select a venue.
              */
              var d = new Date();
              var day = d.getDay(),
                diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
              var first_day_of_week = new Date(d.setDate(diff));
              axios.get('camp-booking/packages', {
                params: {
                    hide_past_dates_running: true,
                    hide_call_to_book: options.days || this.individual_days ? false : true, // JT: If we're showing individual days, we need to show call to book dates as well as sold out dates to give the full picture of availability for the week.
                    min_start_date: (options.days || this.individual_days ? first_day_of_week.toISOString().split('T')[0] : null), // JT: Causing dates that have already started to not show, shouldn't be required as long as venue_week_id is being provided
                    base_package_id: ((options.days || this.individual_days) ? null : (this.isQuickAdd ? this.quickSelection.base.id : (Array.isArray(options.base) ? options.base[0] : options.base) )),
                    package_template_id: ((options.days || this.individual_days) ? null : (this.isQuickAdd ? this.quickSelection.base.id : (Array.isArray(options.base) ? options.base[0] : options.base) )),
                    price_per: (options.days || this.individual_days ? 'day' : 'week'),
                    age: (this.isQuickAdd ? null : (this.isQuickAdd ? this.quickSelection.age : (Array.isArray(options.age) ? options.age[0] : options.age))),
                    venue_week_id: (options.days || this.individual_days ? null : (this.isQuickAdd ? this.quickSelection.week : (Array.isArray(options.week) ? options.week[0] : options.week) )),
                    venue_id: this.$route.params.hasOwnProperty('venueId') ? this.$route.params.venueId : this.toSwap.venue_id,
                    show_programme_id_list: true.toString(),
                    only_base_packages: false.toString(),
                    hide_internal: true
                }
              }).catch(error => {
                this.$root.alert(this.locale.text_empty);
                this.$router.push({
                    name: 'booking.weeks'
                });
                return false;
              }).then(response => {
                this.programmes = response.data.data;

                if (this.programmes.length > 0) {

                    var basePackage = this.base = (false && options.days && !this.$root.config.use_short_weeks ? this.programmes[0] : $.grep(this.programmes, programme => {
                        return programme.id == (this.isQuickAdd ? (Array.isArray(this.quickSelection.base) ? this.quickSelection.base[0].id : this.quickSelection.base.id) : (Array.isArray(options.base) ? options.base[0] : options.base) );
                    })[0]);

                    if (basePackage == undefined || this.base == undefined) {
                        let targetId = Array.isArray(options.base) ? options.base[0] : options.base;
                        let filteredProgrammes = this.programmes.filter(p => p.id !== targetId);
                        let nextBestIndex = filteredProgrammes.findIndex(p => p.status_id == 2);
                        if (nextBestIndex === -1) {
                            nextBestIndex = 0;
                        }
                        this.base = filteredProgrammes[nextBestIndex];
                        basePackage = this.base;
                    }

                    //  Clearing any programmes which aren't the same type as base
                    // if( (options.days || this.individual_days)) {
                    //     this.programmes = this.programmes.filter(programme => {
                    //         return programme.package_template_id == basePackage.package_template_id &&
                    //         programme.name == basePackage.name;
                    //         // JT: Added line to check whether programme is same as base as API doesn't pull back all the dates when searching the API by base_package_id for individual days.
                    //     });
                    // }

                    var isEditing = this.isEditing;
                    var toSwap = this.toSwap;

                    this.optionsHeader = basePackage.name + ' Programme'
                    this.selection.min_age = basePackage.min_age;
                    this.selection.max_age = basePackage.max_age;

                    /**
                     * Working through all the packages to get data for the options (times + addons, etc.)
                     */
                    var timesArray = [];
                    var current = undefined;
                    var packageArray = [];
                    this.programmes.forEach(function(programme) {


                        /**
                         * Adding the times to an array of times to select
                         *
                         * @type {{id: *, description: *, description: *}}
                         */
                        timesArray.push({
                            id: programme.times_id,
                            description: programme.times_description,
                            title: programme.times_title,
                            price: (programme.price - basePackage.price)
                        });

                        //If we are editing, we want all packages as we could change times
                        if (isEditing && toSwap !== undefined) {
                            packageArray.push(programme);
                        } else {
                            //If not editing, we initially only want to load programmes that match the base package time
                            if (programme.times_id == basePackage.times_id && programme.programme_ids) {
                                if (!current || (current.end_date < programme.end_date)) {
                                    current = programme;
                                }
                                packageArray.push(programme);
                            }
                        }

                    });



                    //Order times array by custom string
                    var orderTimes = this.$root.config.order_times;
                    if (orderTimes != undefined) {

                        var preserveTimeArray = timesArray;
                        var timesArray = [];

                        orderTimes.forEach(orderTime => {
                            preserveTimeArray.forEach(time => {
                                if (time.title == orderTime) {
                                    timesArray.push(time);
                                }
                            });
                        });

                        //Get any times that weren't included in the order array
                        var originalTimesMissed = preserveTimeArray.filter(function(obj) {
                            return !timesArray.some(function(obj2) {
                                return obj.title == obj2.title;
                            });
                        });

                        //Combine
                        var timesArray = timesArray.concat(originalTimesMissed);

                    }

                    /**
                     * Adding the extracted times/addons to the component's variables to send to appropriate child components.
                     * Also removing any duplicates here.
                     *
                     * @type {*[]|Array.<*>}
                     */

                    this.times = timesArray.filter(function(item, pos, self) {
                        return self.map(function(e) {
                            return e.id;
                        }).indexOf(item.id) == pos;
                    });

                    this.addons = packageArray;
                    if (packageArray.length == 1) {
                        this.selection.packages = [packageArray[0].id];
                        this.selection.min_age = packageArray[0].min_age;
                        this.selection.max_age = packageArray[0].max_age;
                        this.selection.hour = packageArray[0].times_id;
                    }

                    //Set the hour here as we may unset it in edit/swap if we don't have the same time available
                    if (!isEditing && !toSwap) {
                        this.selection.hour = current.times_id;
                    }

                    if (this.isEditing && this.toSwap) {

                        //Store the current selection of days for comparison later
                        if (this.days == true) {
                            this.selection.current_day_selection = this.selection.days_running;
                        }

                        //Need to check here if the to swap package ID is in the package array returned, if so set it, if not go by programme_ids
                        var matchingPackage = false;
                        var currentPackageId = this.toSwap.package_id;
                        var sameHoursOffered = false;

                        //Loop through package array
                        packageArray.filter(packages_returned => {
                            if (packages_returned.id == currentPackageId) {
                                matchingPackage = true;
                                sameHoursOffered = true;
                            }
                        });

                        current = this.toSwap;
                        this.updateAddons(current.times_id);
                        this.selection.packages.push(this.toSwap.package_id);
                        this.selection.toSwapPackage = this.toSwap.package_id;

                        //If no matching package let's look at programme IDs
                        if (!matchingPackage && this.toSwap.package_id) {

                            var similarPackageFound = false;

                            /**
                             * Get current programme_ids of the current package
                             */

                            axios.get('camp-booking/packages/' + currentPackageId, {
                                params: {
                                    show_programme_id_list: true.toString()
                                }
                            }).catch(error => {
                                this.$root.alert(this.locale.text_empty);
                                this.$router.push({
                                    name: 'booking.weeks'
                                });
                                return false;
                            }).then(response => {

                                //Get current programme IDs
                                this.current_programme_ids = response.data.data.programme_ids;

                                //Loop through package array to find one with matching time, and programme Ids
                                packageArray.filter(packages_returned => {

                                    //Can we offer the same hours?
                                    if (packages_returned.times_id == this.toSwap.times_id) {
                                        sameHoursOffered = true;
                                    }

                                    if (packages_returned.times_id == this.toSwap.times_id && packages_returned.programme_ids.sort().join(',') === this.current_programme_ids.sort().join(',')) {

                                        //We have a match on time and programme IDs, set the selection
                                        similarPackageFound = true;
                                        current = packages_returned;
                                        current.package_id = current.id;
                                        this.updateAddons(current.times_id);
                                        this.selection.packages = [packages_returned.id];
                                        this.selection.toSwapPackage = packages_returned.id;

                                        //Check the addon
                                        jQuery("input[name='packageSelection']#" + current.package_id).closest('.add-on-block').addClass("checked");
                                    }
                                });

                                if (sameHoursOffered == true) {

                                    this.selection.hour = this.current.times_id;
                                } else {
                                    this.selection.hour = null;
                                }

                            });

                        }

                        //Remove hour selection if we don't have the same times available
                        if (sameHoursOffered == true) {
                            this.selection.hour = this.current.times_id;
                        } else {
                            this.selection.hour = null;
                        }

                        //If we don't have a matching package set the selection as empty
                        if (!matchingPackage && typeof similarPackageFound !== 'undefined' && similarPackageFound == false) {
                            this.selection.packages = [];
                        }

                    }

                    //Set time and assign current object
                    this.current = current;

                    /**
                     * Setting the headers
                     **/
                    if (!this.isQuickAdd) {
                        var breadcrumbs = [{
                            to: {
                                name: 'booking.age',
                                query: {}
                            },
                            title: (options.days ? 'Multi Active Programmes' : 'Rookie Academy Programmes')
                        }];
                        if (!options.days) {
                            var start = new Date(this.programmes[0].start_date);

                            breadcrumbs.push({
                                to: {
                                    name: 'booking.weeks',
                                    query: {
                                        min_age: options.min_age,
                                        max_age: options.age
                                    }
                                },
                                title: start.formatRange(this.programmes[0].end_date)
                            });
                            breadcrumbs.push({
                                to: {
                                    name: 'booking.packages',
                                    query: Object.assign(this.$route.query, {
                                        back: true
                                    })
                                },
                                title: this.base.name
                            })
                        }
                        this.$root.headers = {
                            navigate: {
                                name: (options.days ? 'booking.age' : 'booking.packages'),
                                query: {
                                    age: (options.days ? undefined : this.$route.query.age),
                                    min_age: (options.days ? undefined : this.$route.query.min_age),
                                    week: (options.days ? undefined : this.$route.query.week),
                                    back: true
                                }
                            },
                            title: (options.days ? this.$root.locale.miscellaneous.page_headings.booking.select_days : this.$root.locale.miscellaneous.page_headings.booking.select_package),
                            breadcrumbs: breadcrumbs

                        }
                    }
                } else {
                    this.$root.alert(this.locale.text_empty);
                    this.$router.push({
                        name: 'booking.age'
                    });
                }
                this.loading = false;
              });
            },
            simulation: _.debounce(
                function($participants, $packages) {

                    //If the package is not on sale, don't simulate. A message is shown at the bottom with the state of the package.
                    if(!this.current || (this.current && this.current.package_state_id != 2 && this.current.package_state_id != undefined))
                       return false

                    var token = this.token = Math.random().toString(36).substr(2);
                    //Stopping the simulate process unless there are actual participants or a package has been selected.
					//(this.individual_days && this.selection.days_running.length == 0)
                    if(!$participants.length || !$packages.length) {

						//If we have a package we can update the "From" price here
						if ($packages.length && !this.individual_days) {
							//Loop through package array to get the price
							this.programmes.filter(packages_returned => {
								if (packages_returned.id == this.selection.packages[0]) {
									this.fromPrice = packages_returned.price;
								}
							});
						}

						//Stop simulation
                        this.simulate = null;
                        return false;
                    }

                    if(this.individual_days && this.selection.days_running.length <= 2) {
                        this.simulate = null;
                        return false;
                    }

					//Do we have a time selected? e.g. changing from MA to Team Challenge times do not match
					if (!this.individual_days && this.selection.hour == null && this.toSwap != undefined && this.toSwap) {
						this.simulate = null;
                        return false;
					}

                    if(this.individual_days && this.selection.days_running.length > 0) {
                        let error = false;
                        let message = " ";
                        this.selection.days_running.forEach((days, programmeId) => {
                            let programmeObject = $.grep(this.programmes, programme => {
                                return programme.id == programmeId;
                            });
                            if (programmeObject.length == 0) {
                                error = true;
                                message = "An error occurred with the selected days, please refresh the page and try again";
                                return false;
                            }
                            if(programmeObject[0].venue_id == 257 || programmeObject[0].venue_id == 281 || programmeObject[0].venue_id == 157 || programmeObject[0].venue_id == 75) {
                                // Venue specific request to allow 1 day selections
                                if(days.length < 1 && programmeObject[0].days_running.length !== days.length) {
                                error = true;
                                message = "You must select at least 1 days per week";
                                }
                            }
                            else if(days.length <= 2 && programmeObject[0].days_running.length !== days.length) {
                                error = true;
                                message = "You must select at least 3 days per week";
                            }
                            // Venue specific request to always choose a Monday
                            if((programmeObject[0].package_template_id == 844 || programmeObject[0].package_template_id == 845) && (days.indexOf(programmeObject[0].days_running[0]) == -1)) {
                                error = true;
                                message = "You must choose the first day of the week";
                            }
                        })

                        if(error) {
                            this.simulate = {
                                code: 500,
                                message: message
                            }
                            return false;
                        }

                    }

                    this.simulate = {
                        individual_cost: null,
                        original_cost: null,
                        original_cost_calculation: ""
                    }
                    this.discounts = this.fees = [];

                    var params = {};
					var contains_days_running = false;

					$packages.forEach(packageId => {
						$participants.forEach(participantId => {
							params[participantId.toString()+"|"+packageId.toString()] = {
								package_id: packageId,
								participant_id: participantId,
							};
							if(this.selection.days_running[packageId]) {
								contains_days_running = true;
								params[participantId.toString()+"|"+packageId.toString()]['dates_attending'] = this.selection.days_running[packageId];
							}
						});
					});

                    if(this.toSwap != undefined && this.toSwap) {

						//Check we have days running for days
						if (this.individual_days && !contains_days_running) {
							return false;
						}

                        axios.put('camp-booking/bookings/' + this.$route.params.bookingId + '/items/' + this.$route.params.bookingItemId + '/swap' + (this.individual_days ? '/similar' : '') + '/simulate', params)
                            .then(response => {
                                if(token == this.token) {

                                    this.simulate = response.data.data.booking;
                                    this.simulate.individual_cost = response.data.data.booking_items_supplied_total_cost;

                                    /**
                                     * Calculating the discounts
                                     **/
                                    this.discounts = [];
                                    this.fees = [];
                                    this.simulate.original_cost = response.data.data.booking_items_supplied_package_full_price_sum;
                                    Object.keys(response.data.data.booking_items).map(key => {
                                        return response.data.data.booking_items[key];
                                    }).forEach(booking_item => {
                                        Object.keys(booking_item.discounts).forEach(discount_id => {
                                            var discount = booking_item.discounts[discount_id];
                                            this.discounts[discount.discount_id] = {
                                                discount_amount: ( this.discounts[discount.discount_id] ? this.discounts[discount.discount_id].discount_amount + discount.discount_amount : discount.discount_amount),
                                                discount_description: discount.discount_details.name,
                                            };
                                        })
                                        Object.keys(booking_item.fees).forEach(fee_id => {
                                            var fee = booking_item.fees[fee_id];
                                            this.fees[fee.discount_id] = {
                                                discount_amount: ( this.fees[fee.discount_id] ? this.fees[fee.discount_id].discount_amount + fee.discount_amount : fee.discount_amount),
                                                discount_description: fee.discount_details.name,
                                            };
                                        })
                                    })
                                    this.simulate.original_cost = Math.abs(this.simulate.original_cost).toFixed(2);
                                    if(!(this.$root.config.use_short_weeks && this.individual_days))
                                        this.simulate.original_cost_calculation = response.data.data.booking_items_supplied_package_full_price_calculation;
                                    else
                                        this.simulate.original_cost_calculation = "";

                                    this.fees = this.fees.filter(function () {
                                        return true;
                                    });
                                    this.discounts = this.discounts.filter(function () {
                                        return true;
                                    });

                                    /** Updating the basket count **/
                                    this.$root.updateBasketCount();
                                }
                            }).catch(error => {
                                this.simulate = error.response.data.data;
                                this.$root.alert(error.response.data.data.message);
                        })

						//Should we enable or disable the continue/make changes button?
						if(this.isEditing && !this.individual_days && (this.toSwap && $packages.indexOf(this.toSwap.package_id) > -1)) {

                            this.disabled = true;

                        } else if(this.individual_days) {

                            //Get current selection of dates running and compare against existing
                            var currentSelectedDates = [];
                            this.selection.current_day_selection.forEach( function(selected_package_dates) {
                                currentSelectedDates = currentSelectedDates.concat(selected_package_dates);
                            });

							//Get current selection of dates running and compare against existing
							var selectedDates = [];
							this.selection.days_running.forEach( function(selected_package_dates) {
								selectedDates = selectedDates.concat(selected_package_dates);
							});

							//Do both arrays as strings match?
							if ( selectedDates.join(',') === currentSelectedDates.join(',')) {
								this.disabled = true;
							} else {
								this.disabled = false;
							}

                        } else {
                            this.disabled = false;
                        }

                        return true;
                    }

                    axios.post('camp-booking/bookings/'+this.$root.getCookie('kingscamps_booking_id')+'/items/simulate', params)
                        .then(response => {
                            if(token == this.token) {

                                this.simulate = response.data.data.booking;
                                this.simulate.individual_cost = response.data.data.booking_items_supplied_total_cost;

                                /**
                                 * Calculating the discounts
                                 **/
                                this.discounts = [];
                                this.fees = [];
                                this.simulate.original_cost = response.data.data.booking_items_supplied_package_full_price_sum;
                                Object.keys(response.data.data.booking_items).map(key => { return response.data.data.booking_items[key]; }).forEach( booking_item => {
                                    Object.keys(booking_item.discounts).forEach(discount_id => {
                                        var discount = booking_item.discounts[discount_id];
                                        this.discounts[discount.discount_id] = {
                                            discount_amount: ( this.discounts[discount.discount_id] ? this.discounts[discount.discount_id].discount_amount + discount.discount_amount : discount.discount_amount),
                                            discount_description: discount.discount_details.name,
                                        };
                                    })
                                    Object.keys(booking_item.fees).forEach(fee_id => {
                                        var fee = booking_item.fees[fee_id];
                                        this.fees[fee.discount_id] = {
                                            discount_amount: ( this.fees[fee.discount_id] ? this.fees[fee.discount_id].discount_amount + fee.discount_amount : fee.discount_amount),
                                            discount_description: fee.discount_details.name,
                                        };
                                    })
                                })
                                this.simulate.original_cost = Math.abs(this.simulate.original_cost).toFixed(2);
                                if(!(this.$root.config.use_short_weeks && this.individual_days))
                                    this.simulate.original_cost_calculation = response.data.data.booking_items_supplied_package_full_price_calculation;
                                else
                                    this.simulate.original_cost_calculation = "";

                                this.fees = this.fees.filter(function(){return true;});
                                this.discounts = this.discounts.filter(function(){return true;});

                                /** Updating the basket count **/
                                this.$root.updateBasketCount();
                            }
                        }).catch(error => {
                        this.simulate = error.response.data.data;
                    });
                },

                500
            ),
        },
        computed: {
            individual_days_from_price: function () {
                let amount = 0, price = 0;
                let actual_days_selected = [];
                let index=0;

                this.selection.days_running.forEach(day => {
                    if(day != undefined)
                        amount += day.length;
                        actual_days_selected.push(day);
                        index += 1;
                })

                if(this.individual_days) {

                    // Venue-specific request to allow single day bookings
                    if (this.base.venue_id == 257 || this.base.venue_id == 281 || this.base.venue_id == 157 || this.base.venue_id == 75) {
                        price = this.base.price;
                    }
                    else {
                        actual_days_selected.forEach(day => {
                        amount = day.length;
                        if (amount < 4) {
                            price += this.base.three_day_price * 3;
                        }
                        else {
                            var numbers = ['three', 'four', 'five'];
                            var price_variable = `${numbers[amount - 3]}_day_price`;
                            price += this.base[price_variable]*amount;
                        }
                    })
                    }
                }
                else {
                    if(amount == 0) {
                        price = this.base.price;
                    } else {
                    //Go through each package on the selection and find the price
                    this.selection.packages.forEach(packageId => {
                        //Searching the programmes for this id
                        let programmeObject = $.grep(this.programmes, programme => {
                            return programme.id == packageId;
                        });
                        if(programmeObject.length > 0) {
                            //price += programmeObject[0].price*this.selection.days_running[packageId].length;
                            // var numbers = ['three', 'four', 'five'];
                            // var price_variable = `${numbers[this.selection.days_running[packageId].length - 3]}_day_price`;
                            // price += programmeObject[0].price_variable*this.selection.days_running[packageId].length;
                            price += programmeObject[0].price*this.selection.days_running[packageId].length;
                        }

                    })
                }
                }
                return price;
            },
            individual_days: function () {
                let days;
                return (this.$route.query.hasOwnProperty('days') ? this.$route.query.days == 'true' || this.$route.query.days == true : (this.days != undefined && this.days == true) )
            },
            isQuickAdd: function () {
                return this.quick != undefined && this.quick == true;
            },
            isEditing: function () {
                return this.edit != undefined && this.edit == true;
            },
            locale: function () {
                return this.$root.locale.booking.packages;
            }
        },
        components: {
            'individual-days-selection': require('./PackageOptions/IndividualDays.vue'),
            'short-weeks-selection': require('./PackageOptions/ShortWeeks.vue'),
            'hour-selection': require('./PackageOptions/HourSelection.vue'),
            'addon-selection': require('./PackageOptions/AddonSelection.vue'),
            'whos-attending': require('./PackageOptions/WhosAttending.vue')
        },
        watch: {
            'quickSelection.base': function (selectedBasePackage) {
                this.load();
            },
            'selection.packages': function () {
                //Package selection changed
                this.simulation(this.selection.participants, this.selection.packages);
            },
            'selection.participants': function (oldVal, newVal) {
                //Partipant Changed
                this.simulation(this.selection.participants, this.selection.packages);
            },
            'selection.days_running': function (oldVal, newVal) {
                this.simulate = null;
                //Partipant Changed
                this.simulation(this.selection.participants, this.selection.packages);
            },
            '$route' (to) {
                this.load();
            }
        },
        created() {
            this.load();
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// PackageOptions.vue?4ce38cfc